import React from "react";

import { useGetTranslationConfig } from "../../../components/hooks";
import { getTranslationValue } from "../../../services";
import { Select } from "../../atoms";
import { useTableContext } from "../../providers";
import { IKeyStringAndValue } from "../../types/Types";

interface ISelectFilter {
  id: string;
  filter: string;
  allCategories: Array<string>;
  filteredCategories?: Array<string>;
  setFilterOptions: React.Dispatch<React.SetStateAction<IKeyStringAndValue>>;
  filterOptions: IKeyStringAndValue;
  checkFirstSelect?: boolean;
  allOption?: boolean;
  noSort?: boolean;
}

export default function SelectFilter({
  id,
  filter,
  allCategories,
  filteredCategories,
  setFilterOptions,
  filterOptions,
  checkFirstSelect,
  allOption = true,
  noSort = false,
}: ISelectFilter) {
  const { listView } = useTableContext();
  const translations = useGetTranslationConfig(listView)
    .data as Array<IKeyStringAndValue>;

  const checkIfMakeIsDefault = Object.entries(filterOptions).some((a) => {
    return a[0] === "make" && a[1] === "default";
  });
  const removeDefaultValues = Object.entries(filterOptions).reduce((acc, a) => {
    if (a[1] !== "default") {
      acc = { ...acc, [a[0]]: a[1] };
    }
    return acc;
  }, {});

  const compareOptionValuesAscending = (a: string, b: string) => {
    return a?.toLowerCase().localeCompare(b?.toLowerCase(), undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };
  const compareOptionValuesDecending = (a: string, b: string) => {
    return b?.toLowerCase().localeCompare(a?.toLowerCase(), undefined, {
      numeric: true,
      sensitivity: "base",
    });
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (!checkFirstSelect)
      setFilterOptions({
        ...removeDefaultValues,
        [filter]: e.target.value,
      });
    else
      setFilterOptions({
        [filter]: e.target.value,
      });
  };

  return (
    <Select
      square
      key={id}
      //@ts-ignore
      onChange={handleChange}
      value={
        Object.keys(filterOptions).length === 0 ||
        (Object.keys(filterOptions).includes("make") &&
          Object.keys(filterOptions).length === 1 &&
          !checkFirstSelect)
          ? "default"
          : undefined
      }
    >
      {allOption ? <option value={"default"}>Alla</option> : null}
      {noSort
        ? allCategories.map((element: string) => {
            return element !== "" && element !== "-" ? (
              <option key={`${element}`} value={element}>
                {getTranslationValue(element, filter, translations)}
              </option>
            ) : null;
          })
        : filter !== "model"
        ? allCategories
            ?.sort(
              filter === "mda_start" || filter === "mda_end"
                ? compareOptionValuesDecending
                : compareOptionValuesAscending
            )
            .map((element: string) => {
              return element !== "" && element !== "-" ? (
                <option key={`${element}`} value={element}>
                  {getTranslationValue(element, filter, translations)}
                </option>
              ) : null;
            })
        : Object.keys(filterOptions).includes("make") &&
          filter === "model" &&
          !checkIfMakeIsDefault
        ? filteredCategories
            ?.sort(compareOptionValuesAscending)
            .map((element: string) => {
              return element !== "" && element !== "-" ? (
                <option key={`${element}`} value={element}>
                  {element}
                </option>
              ) : null;
            })
        : null}
    </Select>
  );
}
